import React, { useEffect, useState } from "react";
import Stories from "./Stories/stories";
import Messenger from "./messenger/messenger";
import Post from "./post/post";
import axios from "../../services/httpServices";
import Pusher from "pusher-js";
import "./feed.css";

const pusher = new Pusher("8227430c30457f315993", {
  cluster: "ap2",
});

const Feed = () => {
  const [postData, setPostData] = useState([]);
  const syncFeed = () => {
    axios.get("/posts").then((res) => {
      setPostData(res.data);
    });
  };

  useEffect(() => {
    const channel = pusher.subscribe("posts");
    channel.bind("inserted", (data) => {
      syncFeed();
    });
  }, []);
  useEffect(() => {
    syncFeed();
  }, []);
  return (
    <div className="feed-wrapper">
      <Stories />
      <Messenger />
      {postData.map((entry) => (
        <Post
          profilePic={entry.avatar}
          message={entry.text}
          timestamp={entry.timestamp}
          imgName={entry.imgName}
          username={entry.user}
        />
      ))}
    </div>
  );
};

export default Feed;
